(function () {
  // Strip everything but letters/digits so "8 oz", "8-oz" and "8_oz" all
  // compare equal.
  function normalize(str) {
    return (str || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
  }

  // Images are opted into variant filtering explicitly via a "variant_<value>"
  // marker in their alt text (e.g. alt="variant_8oz"). Plain marketing alt
  // text without that marker is never touched, so a word like "Red" or
  // "Small" appearing incidentally in an alt (e.g. "Bread", "Small-batch")
  // can't cause an unrelated image to be hidden.
  function variantTagBlob(alt) {
    var match = /variant[_-]?(.+)$/i.exec(alt || '');
    return match ? normalize(match[1]) : null;
  }

  function readJSONAttribute(root, name) {
    try {
      return JSON.parse(root.getAttribute(name) || '[]');
    } catch (e) {
      return [];
    }
  }

  // Splide caches each slide's measured width (autoWidth mode) and its
  // drag/scroll bounds once at mount, and never recomputes them just
  // because we toggled some slides to display:none. Nudging it with
  // .refresh() proved unreliable (still landed on wrong pixel offsets, and
  // once broke the carousel outright), so instead fully tear down and
  // rebuild the instance via the theme's own destroySlideshow/makeSlideshow
  // - that guarantees fresh widths and bounds computed from the DOM exactly
  // as it exists right now, the same as a normal page load would produce.
  function rebuildSlideshows(root) {
    if (!window.makeSlideshow || !window.destroySlideshow || !window.slideshows) return;
    root.querySelectorAll('.splide--product').forEach(function (splideRoot) {
      try {
        var thumbsId = splideRoot.getAttribute('data-thumbnails');
        if (thumbsId) {
          var thumbsRoot = document.getElementById(thumbsId);
          if (thumbsRoot && window.slideshows[thumbsRoot.id]) {
            window.slideshows[thumbsRoot.id].destroy();
            delete window.slideshows[thumbsRoot.id];
          }
        }
        window.destroySlideshow(splideRoot);
        window.makeSlideshow(splideRoot);
      } catch (e) {
        // best-effort only - a rebuild failure here shouldn't break anything else
      }
    });
  }

  function filterMedia(root, variantOptions) {
    var variantTags = (variantOptions || []).map(normalize);
    var elements = root.querySelectorAll('[data-media-id]');
    var visibilityByEl = [];

    elements.forEach(function (el) {
      var imgEl = el.querySelector('img');
      var blob = variantTagBlob(imgEl ? imgEl.alt : '');
      var visible = true;

      if (blob) {
        visible = variantTags.some(function (tag) {
          return tag && blob.indexOf(tag) !== -1;
        });
      }

      visibilityByEl.push([el, visible]);
    });

    // Never hide every piece of media for a gallery - fall back to showing
    // everything rather than leaving the gallery empty on a false positive.
    var anyVisible = visibilityByEl.some(function (pair) {
      return pair[1];
    });

    var signatureParts = [];
    visibilityByEl.forEach(function (pair) {
      var el = pair[0];
      var visible = anyVisible ? pair[1] : true;
      el.classList.toggle('gallery-media-hidden', !visible);
      signatureParts.push(el.getAttribute('data-media-id') + ':' + visible);
    });

    // filterMedia can run twice for the same variant change (once via a
    // direct synchronous call, once via the theme:variant:change event) -
    // only rebuild the carousel when the actual visible set changed.
    var signature = signatureParts.join(',');
    if (root.getAttribute('data-gallery-filter-signature') === signature) return;
    root.setAttribute('data-gallery-filter-signature', signature);

    rebuildSlideshows(root);
  }

  function initRoot(root) {
    filterMedia(root, readJSONAttribute(root, 'data-gallery-initial-options'));
  }

  document.querySelectorAll('[data-product-root]').forEach(initRoot);

  document.addEventListener('theme:variant:change', function (event) {
    var root = event.detail && event.detail.productRootEl;
    if (!root) return;
    var options = event.detail.variant ? event.detail.variant.options : [];
    filterMedia(root, options);
  });

  // Exposed so other scripts (e.g. the product Alpine component choosing
  // which media to jump to on variant change) can force the filter to run
  // synchronously instead of relying on the "theme:variant:change" event
  // having already been handled.
  window.applyGalleryVariantFilter = filterMedia;

  // Clicking a thumbnail's <a> to sync Alpine's currentMediaId can make
  // mobile browsers auto-scroll the page to bring that link into view,
  // which visually "hides" the main image simply by scrolling it off
  // screen. Restore the scroll position immediately after.
  function clickWithoutScrolling(el) {
    if (!el) return;
    var x = window.scrollX;
    var y = window.scrollY;
    el.click();
    window.scrollTo(x, y);
  }
  window.clickGalleryThumbnailWithoutScrolling = clickWithoutScrolling;

  // On mobile the actual next/prev buttons are Splide's own native
  // ".splide__arrow" elements, which Splide wires up itself to call
  // go('<')/go('>') - a plain relative step that knows nothing about our
  // variant filtering and happily lands on a hidden slide. Intercept the
  // click in the capture phase (before Splide's own bubble-phase handler
  // runs), pick the next slide that isn't gallery-media-hidden ourselves,
  // and stop the native handler from also firing.
  document.addEventListener('click', function (event) {
    var arrowBtn = event.target.closest('.splide__arrow--prev, .splide__arrow--next');
    if (!arrowBtn) return;
    var splideRoot = arrowBtn.closest('.splide');
    if (!splideRoot || !splideRoot.id || !window.slideshows) return;
    var instance = window.slideshows[splideRoot.id];
    if (!instance || !instance.Components || !instance.Components.Slides) return;

    var slides = instance.Components.Slides.get();
    var total = slides.length;
    if (!total) return;

    var step = arrowBtn.classList.contains('splide__arrow--prev') ? -1 : 1;
    var index = instance.index;
    var target = null;
    for (var i = 0; i < total; i++) {
      index = (index + step + total) % total;
      var candidate = slides[index];
      if (candidate && !candidate.slide.classList.contains('gallery-media-hidden')) {
        target = candidate;
        break;
      }
    }
    if (!target) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    instance.go(target.index);

    var mediaId = target.slide.dataset.mediaId;
    var productRoot = splideRoot.closest('[data-product-root]') || document;
    var thumbnail = productRoot.querySelector('[data-media-id="' + mediaId + '"] .media-thumbnail');
    clickWithoutScrolling(thumbnail);
  }, true);
})();
